import React from "react";
import { useNavigate } from "react-router-dom";
import TrailerTab from "./components/TrailerTab";
import { AddButton } from "../../components/common/AddButton";
import PageTitle from "../../components/common/PageTitle";
import { TrailersIcon } from "../../components/common/pageIcons";
import PageLayout from "../../components/layout/PageLayout";

const TrailersPage: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate("/trailers/create");
  };

  return (
    <PageLayout>
      <PageTitle
        title="Trailers"
        icon={<TrailersIcon />}
        actions={<AddButton onClick={handleCreateClick}>Add Trailer</AddButton>}
      />
      <TrailerTab />
    </PageLayout>
  );
};

export default TrailersPage;